import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "dashboader-area mb-25" }
const _hoisted_3 = { class: "tp-dashboard-tab" }
const _hoisted_4 = { class: "tp-dashboard-tab-title" }
const _hoisted_5 = { class: "tp-dashboard-tab-list" }
const _hoisted_6 = { class: "tpd-table mb-25" }
const _hoisted_7 = { class: "tpd-table-head" }
const _hoisted_8 = { class: "tpd-table-row" }
const _hoisted_9 = { class: "tpd-order-id" }
const _hoisted_10 = { class: "tpd-table-title" }
const _hoisted_11 = {
  key: 0,
  class: "tpd-order-name"
}
const _hoisted_12 = { class: "tpd-table-title" }
const _hoisted_13 = {
  key: 1,
  class: "tpd-order-name"
}
const _hoisted_14 = { class: "tpd-table-title" }
const _hoisted_15 = { class: "tpd-order-date" }
const _hoisted_16 = { class: "tpd-table-title" }
const _hoisted_17 = { class: "tpd-order-price" }
const _hoisted_18 = { class: "tpd-table-title" }
const _hoisted_19 = { class: "tpd-order-status" }
const _hoisted_20 = { class: "tpd-table-title" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "tpd-order-action" }, null, -1 /* HOISTED */)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"placeholder-glow\"><div class=\"d-flex gap-3\"><span class=\"placeholder d-block rounded\" style=\"width:100%;height:30px;\"></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:30px;\"></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:30px;\"></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:30px;\"></span><span class=\"placeholder d-block rounded\" style=\"width:100%;height:30px;\"></span></div></div>", 1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "pe-3 ps-3" }
const _hoisted_27 = { class: "alert alert-warning w-100" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-info-circle mr-1" }, null, -1 /* HOISTED */)
const _hoisted_29 = { class: "tpd-table-row" }
const _hoisted_30 = { class: "tpd-order-id" }
const _hoisted_31 = { class: "tpd-common-text" }
const _hoisted_32 = { class: "tpd-order-name" }
const _hoisted_33 = { class: "tpd-common-text" }
const _hoisted_34 = { class: "tpd-order-date" }
const _hoisted_35 = {
  key: 0,
  class: "tpd-common-text"
}
const _hoisted_36 = {
  key: 1,
  class: "tpd-common-text"
}
const _hoisted_37 = { class: "tpd-order-price" }
const _hoisted_38 = {
  key: 0,
  class: "tpd-common-text"
}
const _hoisted_39 = {
  key: 1,
  class: "tpd-common-text"
}
const _hoisted_40 = { class: "tpd-order-status" }
const _hoisted_41 = {
  key: 0,
  class: "tpd-badge-item"
}
const _hoisted_42 = {
  key: 0,
  class: "tpd-badge warning"
}
const _hoisted_43 = {
  key: 1,
  class: "tpd-badge sucess"
}
const _hoisted_44 = {
  key: 1,
  class: "tpd-badge-item"
}
const _hoisted_45 = {
  key: 0,
  class: "tpd-badge sucess"
}
const _hoisted_46 = { class: "tpd-order-action" }
const _hoisted_47 = { class: "tpd-action-btn" }
const _hoisted_48 = ["href", "download"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "13",
  viewBox: "0 0 14 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 8.23975V10.7466C13 11.079 12.8595 11.3979 12.6095 11.6329C12.3594 11.868 12.0203 12.0001 11.6667 12.0001H2.33333C1.97971 12.0001 1.64057 11.868 1.39052 11.6329C1.14048 11.3979 1 11.079 1 10.7466V8.23975",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.3327 5.38704L6.99935 8.52063L3.66602 5.38704",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 1V8.52061",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */)
const _hoisted_50 = { class: "tpd-action-tooltip" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" dashboard-content-area-start "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" dashboard-tab-area "),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString($setup.lms_website.__('Order History')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["pointer-event", ($data.payments.active_tab==='offline')?'active':'']),
                  onClick: _cache[0] || (_cache[0] = $event => ($data.payments.active_tab='offline'))
                }, [
                  _createTextVNode(_toDisplayString($setup.lms_website.__('Offline Payments')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", null, "(" + _toDisplayString($data.payments.offline?.length) + ")", 1 /* TEXT */)
                ], 2 /* CLASS */)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["pointer-event", ($data.payments.active_tab==='online')?'active':'']),
                  onClick: _cache[1] || (_cache[1] = $event => ($data.payments.active_tab='online'))
                }, [
                  _createTextVNode(_toDisplayString($setup.lms_website.__('Online Payments')) + " ", 1 /* TEXT */),
                  _createElementVNode("span", null, "(" + _toDisplayString($data.payments.online?.length) + ")", 1 /* TEXT */)
                ], 2 /* CLASS */)
              ])
            ])
          ])
        ])
      ]),
      _createCommentVNode(" dashboard-tab-area-end "),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h4", _hoisted_10, _toDisplayString($setup.lms_website.__('Order ID')), 1 /* TEXT */)
              ]),
              ($data.payments.active_tab==='offline')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("h4", _hoisted_12, _toDisplayString($setup.lms_website.__('Program')), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.payments.active_tab==='online')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("h4", _hoisted_14, _toDisplayString($setup.lms_website.__('Course')), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h4", _hoisted_16, _toDisplayString($setup.lms_website.__('Date')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h4", _hoisted_18, _toDisplayString($setup.lms_website.__('Price')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h4", _hoisted_20, _toDisplayString($setup.lms_website.__('Status')), 1 /* TEXT */)
              ]),
              _hoisted_21
            ])
          ]),
          ($data.payments.loading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_22, _hoisted_24))
            : _createCommentVNode("v-if", true),
          (!$options.activePayments?.length && !$data.payments.loading)
            ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Not Payments Found')), 1 /* TEXT */)
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($options.activePayments?.length && !$data.payments.loading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($options.paginatedPayments, (payment) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: payment.name
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("h4", _hoisted_31, "#" + _toDisplayString(payment.name), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("h4", _hoisted_33, [
                        ($data.payments.active_tab==='online')
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/courses/view/${payment.payment_for_document}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(payment.course_title), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                          : _createCommentVNode("v-if", true),
                        ($data.payments.active_tab==='offline')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(payment.custom_program), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      ($data.payments.active_tab==='online')
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_35, _toDisplayString($data.moment(payment.creation).format('MMMM DD, YYYY')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($data.payments.active_tab==='offline')
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_36, _toDisplayString($data.moment(payment.posting_date).format('MMMM DD, YYYY')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      ($data.payments.active_tab==='online')
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_38, _toDisplayString($options.format_currency(payment.amount, payment.currency)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($data.payments.active_tab==='offline')
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_39, _toDisplayString($options.format_currency(payment.paid_amount_after_tax)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      ($data.payments.active_tab==='online')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            (!payment.payment_received)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString($setup.lms_website.__('On Hold')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (payment.payment_received)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString($setup.lms_website.__('Success')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($data.payments.active_tab==='offline')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            (payment.docstatus===1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString($setup.lms_website.__('Success')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("a", {
                          href: `/api/method/frappe.utils.print_format.download_pdf?doctype=${($data.payments.active_tab==='online')?'LMS Payment':'Payment Entry'}&name=${payment.name}&format=Payment Entry Installment&no_letterhead=1&letterhead=No%20Letterhead&settings=%7B%7D&_lang=${$setup.lms_website.user_language}`,
                          download: payment.name
                        }, [
                          _hoisted_49,
                          _createElementVNode("span", _hoisted_50, _toDisplayString($setup.lms_website.__('Download')), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_48)
                      ])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      (!$data.payments.loading)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            "current-page": $data.payments.currentPage,
            "total-items": $options.activePayments?.length,
            "items-per-page": $data.payments.itemsPerPage,
            onPageChanged: $options.handlePageChange
          }, null, 8 /* PROPS */, ["current-page", "total-items", "items-per-page", "onPageChanged"]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}